module.exports = __webpack_public_path__ + "img/tt_screenshot.2d803503.jpg";